import React, { useEffect, useState } from "react";
import Loader from "../../ui_library/ver_24.10/Loader/Loader.comp";
import { APP_STATUS, SEAL_TYPE, TOAST_TYPES } from "../../utils/constants";
import { getApplicationAlignmentService, getApplicationService } from "../../services/app.service";
import { ONLINE_SYSTEM_MAP } from "../../utils/META/cat_117";
import { toast } from "../../utils/utils";
import { useHistory, useParams } from "react-router-dom";
import {
    fetchRatingProgramStatusService,
    enableAssessmentService,
} from "../../services/rating.service";import RatingAssessmentWelcomeView from "../../views/ver_24.10/ProgramRating/RatingAssessmentWelcome.view";

const RatingAssessmentWelcomePage = () => {
    const { programId } = useParams();
    const history = useHistory();

    const application_id = programId;
    const [appData, setAppData] = useState();
    const [status, setStatus] = useState(null);
    const [programStatusV3, setProgramStatusV3] = useState(null);
    const [showLoader, setShowLoader] = useState(false);
    const [isAppAligned, setIsAppAligned] = useState(false);

    const fetchRatingProgram = async () => {
        try {
            setShowLoader(true);
            const result = await fetchRatingProgramStatusService(programId);
            console.log('API Response:', result); // Debug log

            if (result?.data) {
                setStatus(result.data.app_status);
                console.log('Setting status to:', result.data.app_status);
                if (result.data.app_status_v3 < APP_STATUS.PROGRAM_SUMMARY_REPORT_COMPLETED) {
                    history.push(`/rating/${programId}`);
                }
            } else {
                console.error('No status data received');
                setStatus(null);
            }
        } catch (error) {
            console.error('Error fetching program:', error);
            setStatus(null);
        } finally {
            setShowLoader(false);
        }
    };

    useEffect(() => {
        fetchRatingProgram().then(r => console.log(r));
    }, [programId]);

    const updateDQSealType = async () => {
        if (status === APP_STATUS.COMPLETED) {
            try {
                setShowLoader(true);
                const result = await enableAssessmentService(application_id);
                if (result && result.data.program_application && !result.error) {
                    setAppData(result.data.program_application);
                    setStatus(result.data.program_application.app_status)
                }
            } catch (error) {
                console.error(error);
                setShowLoader(false);
            } finally {
                setShowLoader(false);
            }
        }
    }

    useEffect(() => {
        updateDQSealType().then(r => console.log('aj: appData ', appData));
    }, [application_id, status]);

    const getAppAlignment = async () => {
        if (status >= APP_STATUS.READY_TO_CERTIFY) {
            try {
                setShowLoader(true);
                const result = await getApplicationAlignmentService(programId);
                if (result && result.data) {
                    setIsAppAligned(result.data.length > 0);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setShowLoader(false);
            }
        }
    };

    useEffect(() => {
        getAppAlignment();
    }, [programId, status]);

    const accessAssessmentAction = (programId, program_status) => {
        if (program_status === APP_STATUS.ASSESSMENTS_READY) {
            history.push(`/rating/${programId}/access_assessment`);
        } else {
            history.push(`/rating/${programId}/select_assessment`);
        }
    };

    const options = {
        showLoader,
        isAppAligned,
    };

    const actions = {
        accessAssessmentAction
    };

    const data = {
        application_id: programId,
        status: status,
    };

    if (showLoader) {
        return <Loader />;
    }

    return (
        <RatingAssessmentWelcomeView
            options={options}
            actions={actions}
            data={data}
        />
    );
};

export default RatingAssessmentWelcomePage;